import { FC, PropsWithChildren } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box, Container } from '@mui/material';

import { ProgramHeader } from './ProgramHeader';


const programTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ee982b',
      contrastText: '#1E3A47',
    },
    background: {
      default: '#004A64',
      paper: '#365D6E',
    },
    text: {
      primary: '#F5F0E8',
      secondary: '#9FB8C4',
    },
  },
  typography: {
    fontFamily: '"Georgia", "Times New Roman", serif',
    h3: { fontFamily: '"Georgia", serif', letterSpacing: '0.02em' },
    h4: { fontFamily: '"Georgia", serif', letterSpacing: '0.02em' },
    h5: { fontFamily: '"Georgia", serif' },
    h6: { fontFamily: '"Georgia", serif' },
    overline: { letterSpacing: '0.15em' },
    button: { fontFamily: '"Inter", "Helvetica", sans-serif', letterSpacing: '0.08em', fontWeight: 400 },
    caption: { fontFamily: '"Inter", "Helvetica", sans-serif', letterSpacing: '0.08em' },
    subtitle1: { fontFamily: '"Inter", "Helvetica", sans-serif', letterSpacing: '0.12em', textTransform: 'uppercase' },
    subtitle2: { fontFamily: '"Inter", "Helvetica", sans-serif' },
    body1: { fontFamily: '"Georgia", serif', lineHeight: 1.8 },
    body2: { fontFamily: '"Inter", "Helvetica", sans-serif' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          borderRadius: 24,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          paddingLeft: 32,
          paddingRight: 32,
        },
        outlined: {
          borderRadius: 24,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '& fieldset': { borderColor: 'rgba(245, 240, 232, 0.2)' },
            '&:hover fieldset': { borderColor: 'rgba(245, 240, 232, 0.4)' },
          },
          '& .MuiInputLabel-root': { fontFamily: '"Inter", "Helvetica", sans-serif' },
          '& .MuiInputBase-input': { fontFamily: '"Georgia", serif' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          borderColor: 'rgba(245, 240, 232, 0.3)',
          color: '#F5F0E8',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: 'rgba(245, 240, 232, 0.15)',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        iconFilled: { color: '#D4A254' },
        iconEmpty: { color: 'rgba(245, 240, 232, 0.2)' },
      },
    },
  },
});

export const ProgramLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider theme={programTheme}>
      <Box
        pt="env(safe-area-inset-top)"
        pb="env(safe-area-inset-bottom)"
        sx={{
          minHeight: '100dvh',
          backgroundColor: 'background.default',
          color: 'text.primary',
        }}
      >
        <Container maxWidth="sm" sx={{ py: 2, px: 3 }}>
          <ProgramHeader/>
          {children}
        </Container>
      </Box>
    </ThemeProvider>
  );
};
